/* eslint-disable */
// @ts-nocheck
import type { IServiceExtension, IServiceInstanceOptions } from '../types';
import { v4 as uuid } from 'uuid';

export default class RequestIdExtension implements IServiceExtension<string> {
  public constructor(private readonly options: IServiceInstanceOptions) {}
  public name: string = 'xMessageId';

  public getData = (): string => uuid();
}
